export default "__VITE_ASSET__97f99363__"